import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { ConsultationService } from "@customTypes/consultation";


export const useCreateClinicConsultationService = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (service: Partial<ConsultationService>) => {
      const payload: any = {
        name: service.name,
        category: service.category,
        price: service.price,
        status: service.status,
        service_duration: service.service_duration,
        in_30_min: service.in_30_min,
        sessions: service.sessions,
        session_interval_days: service.session_interval_days,
      };

      if (service.partner_id) {
        payload.partner_id = service.partner_id;
      }

      return api.post("clinic/consultation-services", payload);
    },
    onSuccess: () => {
      // console.log(res.data)
      showSuccessNotification({
        title: "success",
        message: "create-clinic-consultation-service-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.consultationServices(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Clinic Consultation Service]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.consultationServices(),
      });

      handleErrors(res, "mutation");
    },
  });
};
